export var Sort;
(function (Sort) {
    Sort[Sort["ASC"] = 0] = "ASC";
    Sort[Sort["DESC"] = 1] = "DESC";
})(Sort || (Sort = {}));
//# sourceMappingURL=Sort.js.map